import React from 'react'
export default class ReadHealth extends React.Component {
  render () {
    console.log(this.props)
    return (
      <div className="data-information-container data-left">
        <div className="column-information">
          <div className="col-data data-left">
            <div className="labels-data">
              {this.props.arrayDataLabels[0].labelsInfoColumnOne.map(label => (
                <label key={`r${Math.random()}`} className="label-tg-name brdr-bttm">{label}</label>
              ))}
            </div>
            <div className="labels-value">
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.presPRange}>
                  {this.props.presionParadoAlta} /{" "}
                  {this.props.presionParadoBaja}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.presSRange}>
                  {this.props.presionSentadoAlta} /{" "}
                  {this.props.presionSentadoBaja}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.fcRange}>
                  {this.props.frecuencia + ' LPM'}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span>{this.props.peso + ' Kg'}</span>
              </label>
              <label className="label-tg-value brdr-bttm">
                {this.props.altura + ' cm'}
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.IMCRange}>
                  {this.props.imc}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.perAbdRange}>
                  {this.props.pabdominal + ' cm'}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.balIzRange}>
                  {this.props.balanceNeuroIMuscular}
                </span>&nbsp;/&nbsp;<span
                  className={this.props.balDeRange}
                >
                  {this.props.balanceNeuroDMuscular}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.itbiRange}>
                  {this.props.itbi}
                </span>&nbsp;/&nbsp;<span
                  className={this.props.itbdRange}
                >
                  {this.props.itbd}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.vopRange}>
                  {this.props.vop}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.tabaqRange}>
                  {this.props.fuma}
                </span>
              </label>
              <label className="label-tg-value brdr-bttm">
                <span className={this.props.tiempo}>
                  {this.props.tiempoCincoM + ' seg'}
                </span>
              </label>
              <label className="label-tg-value">
                {this.props.temperatura + ' ºC'}
              </label>
            </div>
          </div>
          <div className="col-data-container">
            <div className="emotional-results">
              <div className="labels-data">
                <label className="label-tg-name brdr-bttm">
                  Satisfacción
                </label>
                <label className="label-tg-name brdr-bttm">
                  Contribución
                </label>
                <label className="label-tg-name brdr-bttm">
                  Felicidad
                </label>
                <label className="label-tg-name brdr-bttm">
                  Preocupación
                </label>
                <label className="label-tg-name">Depresión</label>
              </div>
              <div className="labels-value">
                <label className="label-tg-value brdr-bttm">
                  <span className={this.props.satRange}>
                    {this.props.satisfaccion}
                  </span>
                </label>
                <label className="label-tg-value brdr-bttm">
                  <span className={this.props.conRange}>
                    {this.props.depresion}
                  </span>
                </label>
                <label className="label-tg-value brdr-bttm">
                  <span className={this.props.felRange}>
                    {this.props.feliz}
                  </span>
                </label>
                <label className="label-tg-value brdr-bttm">
                  <span className={this.props.preRange}>
                    {this.props.preocupacion}
                  </span>
                </label>
                <label className="label-tg-value">
                  <span className={this.props.decRange}>
                    {this.props.decaido}
                  </span>
                </label>
              </div>
            </div>
            <div className="single-row single-row-bottom ">
              <div className="labels-data">
                <label className="label-tg-name">Actividad física</label>
              </div>
              <div className="labels-value">
                <label className="label-tg-value">
                  <span className={this.props.metsRange}>
                    100
                  </span>
                </label>
              </div>
            </div>
            <div className="emotional-results">
              <div className="labels-data">
                <label className="label-tg-name brdr-bttm">
                  Movilidad
                </label>
                <label className="label-tg-name brdr-bttm">
                  Cuidado personal
                </label>
                <label className="label-tg-name brdr-bttm">
                  Actividades cotidianas
                </label>
                <label className="label-tg-name brdr-bttm">
                  Dolor / Malestar
                </label>
                <label className="label-tg-name">
                  Ansiedad / Depresión
                </label>
              </div>
              <div className="labels-value">
                <label className="label-tg-value brdr-bttm">
                  <span className={this.props.movRange}>
                    10mov
                  </span>
                </label>
                <label className="label-tg-value brdr-bttm">
                  <span className={this.props.cuiRange}>
                  data
                  </span>
                </label>
                <label className="label-tg-value brdr-bttm">
                  <span className={this.props.actRange}>
                  data
                  </span>
                </label>
                <label className="label-tg-value brdr-bttm">
                  <span className={this.props.dolRange}>
                  data
                  </span>
                </label>
                <label className="label-tg-value">
                  <span className={this.props.ansRange}>
                  data
                  </span>
                </label>
              </div>
            </div>
            <div className="single-row">
              <div className="labels-data">
                <label className="label-tg-name">Estado de salud</label>
              </div>
              <div className="labels-value">
                <label className="label-tg-value">
                  {this.props.health}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="notes-information">
          <div className="notes-title">Notas</div>
          <div className="notes-author-notes-date">
            <div className="notes-author">
              Creado por:{" "}
              {this.props.modificadoPor === undefined
                ? ''
                : this.props.creadoPor}
            </div>
            <div className="notes-author">
              Modificado por:{" "}
              {this.props.modificadoPor === undefined
                ? ''
                : this.props.modificadoPor}
            </div>
            <div className="notes-date">
              {this.props.notasText === '' ? '' : this.props.creationDate}
            </div>
          </div>
          <div className="notes-data">{this.props.notasText}</div>
        </div>
      </div>
    )
  }
            
}


// WEBPACK FOOTER //
// ./src/components/Health/ReadHealth.js